export default {
  title: 'Gestiona tu negocio desde cualquier lugar',
  description: 'Inicia sesión en tu cuenta.',
  form: {
    email: {
      label: 'Correo electrónico',
      placeholder: 'Introduce el correo',
    },
    password: {
      label: 'Contraseña',
      placeholder: 'Introduce la contraseña',
    },
    error_messages: {
      missing_info: 'Información faltante',
      wrong_credentials: 'Correo o contraseña incorrectos',
    },
  },
  buttons: {
    login: 'Iniciar sesión',
    forgot_password: 'Olvidé mi contraseña',
  },
  white_label: {
    title: 'Accede a tu panel',
    form: {
      email: {
        label: 'Dirección de correo',
        placeholder: 'tu@restaurante.com',
      },
      password: {
        label: 'Contraseña',
        placeholder: 'Introduce tu contraseña',
      },
    },
    buttons: {
      login: 'Iniciar sesión',
    },
    intro: {
      eyebrow: 'Gestión de pedidos',
      headline: 'Gestiona tu restaurante desde cualquier lugar.',
      description: 'Pedidos, menús, horarios y pagos — todo en un solo lugar.',
      features: {
        live: {
          title: 'En vivo',
          subtitle: 'seguimiento de pedidos',
        },
        instant: {
          title: 'Instantáneo',
          subtitle: 'cambios de menú',
        },
        any_device: {
          title: 'Cualquier dispositivo',
          subtitle: 'teléfono o tablet',
        },
      },
    },
  },
};
